// extracted by mini-css-extract-plugin
export default {"image":"m1-z","loaded":"n1-z"};